module.exports = __webpack_public_path__ + "files/3b07ae854555e68e4b7d3305884ff9f1.svg";